/* =========================================================================
   Tech-Life 2026 - quiz.js
   Find Your Speaker. Loads only on the quiz page. Walks the user through
   each question, accumulates per-category scores, then renders the
   recommended product card by fetching /products/<handle>.js.
   ========================================================================= */
(function () {
  'use strict';

  const root = document.querySelector('[data-quiz]');
  if (!root) return;

  const $  = (sel, ctx = root) => ctx.querySelector(sel);
  const $$ = (sel, ctx = root) => Array.from(ctx.querySelectorAll(sel));

  const screens = $$('[data-quiz-screen]');
  const result  = $('[data-quiz-result]');
  const progressFill   = $('.quiz-progress__fill');
  const stepLabel      = $('[data-quiz-step]');

  const total = screens.length;
  const cats = ['clipon', 'magnetic', 'waterproof', 'multilink', 'bigsound'];
  const handles = {
    clipon:     root.getAttribute('data-rec-clipon'),
    magnetic:   root.getAttribute('data-rec-magnetic'),
    waterproof: root.getAttribute('data-rec-waterproof'),
    multilink:  root.getAttribute('data-rec-multilink'),
    bigsound:   root.getAttribute('data-rec-bigsound')
  };

  let step = 0;
  const scores = { clipon: 0, magnetic: 0, waterproof: 0, multilink: 0, bigsound: 0 };
  // Per-step weights chosen, so Back can subtract cleanly
  const chosen = new Array(total).fill(null);

  const updateProgress = () => {
    const pct = Math.round((step) / total * 100);
    if (progressFill) progressFill.style.width = pct + '%';
    if (stepLabel) stepLabel.textContent = String(Math.min(step + 1, total));
  };

  const showStep = (idx) => {
    screens.forEach((s, i) => s.classList.toggle('is-active', i === idx));
    if (result) result.hidden = true;
    step = idx;
    updateProgress();
    // Reset radio state on re-entry
    screens[idx].querySelectorAll('[data-quiz-choice]').forEach(b => b.setAttribute('aria-checked', 'false'));
    const chose = chosen[idx];
    if (chose) {
      const target = screens[idx].querySelector('[data-weights="' + chose + '"]');
      if (target) target.setAttribute('aria-checked', 'true');
    }
    // Focus first choice
    const first = screens[idx].querySelector('[data-quiz-choice]');
    if (first) first.focus();
  };

  const applyWeights = (weightsStr, sign) => {
    if (!weightsStr) return;
    const parts = weightsStr.split(',').map(n => parseFloat(n) || 0);
    cats.forEach((c, i) => { scores[c] += sign * (parts[i] || 0); });
  };

  const finish = async () => {
    // Compute winner
    let winner = cats[0], best = -Infinity;
    cats.forEach(c => { if (scores[c] > best) { best = scores[c]; winner = c; } });

    if (result) result.hidden = false;
    screens.forEach(s => s.classList.remove('is-active'));
    if (progressFill) progressFill.style.width = '100%';
    if (stepLabel) stepLabel.textContent = String(total);

    const titles = {
      clipon:     'The Clip-On',
      magnetic:   'The Magnetic',
      waterproof: 'The Waterproof',
      multilink:  'The MultiLink Bundle',
      bigsound:   'The BOSS - Big-Sound flagship'
    };
    const blurbs = {
      clipon:     'Compact, packable, and ready to clip onto whatever you grab next.',
      magnetic:   'Sticks to anything ferrous. Loud enough for the shop floor.',
      waterproof: 'IP67-rated, salt-tolerant, and floats. Throw it in the cooler.',
      multilink:  'Two speakers paired = the loudest tailgate on the block.',
      bigsound:   'Flagship power. Big drivers, big battery, big presence.'
    };
    const titleEl = $('[data-quiz-result-title]');
    const blurbEl = $('[data-quiz-result-blurb]');
    if (titleEl) titleEl.textContent = titles[winner];
    if (blurbEl) blurbEl.textContent = blurbs[winner];

    const handle = handles[winner];
    const card = $('[data-quiz-result-card]');
    if (!card) return;

    if (!handle) {
      card.innerHTML = '<p class="fineprint">Configure the recommended product for the "' + winner + '" category in Customize -> Find Your Speaker quiz.</p>';
      return;
    }

    card.innerHTML = '<div class="quiz-result__loading">Loading recommendation...</div>';
    try {
      const res = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error('Could not load product');
      const p = await res.json();
      const v = p.variants[0];
      const img = p.featured_image || (p.images && p.images[0]);

      card.innerHTML = '' +
        '<a class="quiz-result__media" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="quiz-result__body">' +
          '<a class="quiz-result__title" href="' + p.url + '">' + esc(p.title) + '</a>' +
          '<p class="quiz-result__price spec-value">' + window.TL.Money.format(v.price) + '</p>' +
          (p.description ? '<p class="fineprint quiz-result__desc">' + p.description.replace(/<[^>]*>/g, '').slice(0, 200) + '...</p>' : '') +
          '<div class="quiz-result__ctas">' +
            '<button class="btn btn-primary" type="button" data-quiz-add data-variant-id="' + v.id + '">Add to cart - ' + window.TL.Money.format(v.price) + '</button>' +
            '<a class="btn btn-outline" href="' + p.url + '">View full details</a>' +
          '</div>' +
        '</div>';

      const addBtn = card.querySelector('[data-quiz-add]');
      addBtn.addEventListener('click', () => {
        const id = parseInt(addBtn.getAttribute('data-variant-id'), 10);
        if (addBtn.getAttribute('aria-busy') === 'true') return; // block double-submit
        addBtn.setAttribute('aria-busy', 'true');
        window.TL.Cart.add(id, 1)
          .catch(err => console.error(err))
          .finally(() => addBtn.removeAttribute('aria-busy'));
      });
    } catch (e) {
      card.innerHTML = '<p class="fineprint">Could not load product. <a href="/products/' + handle + '">View directly</a>.</p>';
    }
  };

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]);

  // Wire choices
  root.addEventListener('click', (e) => {
    const choice = e.target.closest('[data-quiz-choice]');
    if (choice) {
      const screen = choice.closest('[data-quiz-screen]');
      const idx = parseInt(screen.getAttribute('data-step'), 10) - 1;
      const weights = choice.getAttribute('data-weights');

      // Subtract previous chosen if any
      if (chosen[idx]) applyWeights(chosen[idx], -1);
      // Apply new choice
      applyWeights(weights, +1);
      chosen[idx] = weights;

      // Visual selection
      screen.querySelectorAll('[data-quiz-choice]').forEach(b => b.setAttribute('aria-checked', 'false'));
      choice.setAttribute('aria-checked', 'true');

      // Auto-advance after a short beat
      setTimeout(() => {
        if (idx + 1 < total) {
          showStep(idx + 1);
        } else {
          step = total;
          finish();
        }
      }, 240);
    }

    const prev = e.target.closest('[data-quiz-prev]');
    if (prev) {
      const screen = prev.closest('[data-quiz-screen]');
      const idx = parseInt(screen.getAttribute('data-step'), 10) - 1;
      if (idx > 0) showStep(idx - 1);
    }

    const restart = e.target.closest('[data-quiz-restart]');
    if (restart) {
      cats.forEach(c => { scores[c] = 0; });
      for (let i = 0; i < chosen.length; i++) chosen[i] = null;
      showStep(0);
    }
  });

  // Init
  updateProgress();
})();
